import { ChevronRight } from 'lucide-react';
import { cn } from '@/utils/styles';
import { EventTracker } from '@/utils';

interface CommunityCardProps {
  title: string;
  description: string;
  buttonText: string;
  backgroundImage: string;
  externalLink: string;
  eventName: string;
}

export const CommunityCard = ({
  title,
  description,
  buttonText,
  backgroundImage,
  externalLink,
  eventName,
}: CommunityCardProps) => {
  const handleClick = () => {
    EventTracker.trackEvent('home', eventName);
    window.open(externalLink, '_blank', 'noopener,noreferrer');
  };

  return (
    <div
      className={cn(
        'w-full h-96',
        'p-4',
        'rounded-2xl',
        'relative',
        'overflow-hidden',
      )}
    >
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      />

      <div
        className={cn(
          'absolute inset-0',
          'bg-gradient-to-b from-black/20 to-transparent',
        )}
      />

      <div className="relative">
        <h2 className="typography-h1 text-white mb-4">{title}</h2>
        <p className={cn('typography-body text-white/90', 'h-20')}>
          {description}
        </p>

        <button
          onClick={handleClick}
          className="group flex items-center text-white cursor-pointer"
          aria-label={buttonText}
        >
          <span className="typography-btn-large">{buttonText}</span>
          <ChevronRight className="w-5 h-5 " aria-hidden="true" />
        </button>
      </div>
    </div>
  );
};
